export const ACHIEVEMENT_NAME_OPTIONS = [
  { value: '', label: 'Select...' },
  { value: 'profit_guru', label: 'Profit guru' },
  { value: 'most_popular', label: 'Most popular' },
  { value: 'most_active', label: 'Most active' },
  { value: 'low_risk_king', label: 'Low risk king' },
]
